<template>
  <el-collapse v-model="door.filtersOpen">
    <el-collapse-item
      :title="$t('common.search')"
      name="search-section"
      id="search-section">
      <el-form
        :model="searchForm"
        ref="searchForm"
        label-position="right"
        size="mini"
        class="search-section-form"
        inline>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('door.number')" prop="number">
              <el-input
              v-model="searchForm.number"
              ref="filter-door-number"
              v-numeric-validation
              maxlength="25"
              clearable
              @clear="handleSearch"
              v-on:keyup.enter.native="handleSearch"
              class="inline-input"
              id="searchForm-door-number"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('door.option')" prop="option">
              <el-select v-model="searchForm.option" id="searchForm-option" ref="filter-option" @change="handleSearch">
                  <el-option
                  v-for="item in receivingOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('door.status')" prop="active">
              <el-select v-model="searchForm.active" id="searchForm-active" ref="filter-active" @change="handleSearch">
                  <el-option
                  v-for="item in activeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24" class="text-align-end">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('common.search')"
              placement="top-start">
              <el-button
                id="form-search-button"
                @click="handleSearch"
                icon="el-icon-search"
                size="mini"
                class="button-action-default">
              </el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </el-form>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  name: 'SearchFilters',
  computed: {
    ...mapGetters([
      'door'
    ])
  },
  data() {
    return {
      searchForm: {
        number: null,
        option: constants.DOOR.RECEIVING_OPTIONS[0].value,
        active: constants.DOOR.ACTIVE_OPTIONS[1].value,
      },
      activeCollapsibleName: ['search-section'],
      receivingOptions: constants.DOOR.RECEIVING_OPTIONS,
      activeOptions: constants.DOOR.ACTIVE_OPTIONS
    };
  },
  methods: {
    handleSearch() {
      this.$store.dispatch('door/search', this.searchForm);
    }
  }
};
</script>
